import { useState } from 'react';
import { Mail, ArrowLeft } from 'lucide-react';

export function ForgotPasswordPage({ onNavigate }: { onNavigate: (page: string) => void }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const res = await fetch('/api/v1/auth/password', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        onNavigate('sent');
        return;
      }

      const data = await res.json().catch(() => ({}));
      setError(data.error || 'No pudimos enviar las instrucciones en este momento. Intentá nuevamente.');
    } catch {
      setError('No pudimos conectarnos en este momento. Revisá tu conexión e intentá otra vez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-app-bg p-4">
      <div className="w-full max-w-[24rem] flex flex-col items-center">
        <h1 className="text-3xl font-bold text-zinc-900">Recuperar contraseña</h1>
        <p className="text-zinc-500 mt-2 mb-6 text-center">
          Ingresa tu email y te enviaremos instrucciones para restablecer tu contraseña.
        </p>

        {error && (
          <div className="w-full mb-4 px-4 py-3 rounded-lg bg-red-100 border border-red-500 text-red-700 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="w-full space-y-4">
          <div className="relative">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-zinc-400">
              <Mail className="h-5 w-5" />
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
              autoComplete="email"
              className="w-full py-3 pl-10 pr-4 mt-1 border border-zinc-300 rounded-3xl bg-white text-zinc-900 placeholder-zinc-400 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full mt-5 px-4 py-3 rounded-lg bg-violet-600 text-white font-medium hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Enviando…' : 'Enviar instrucciones'}
          </button>
        </form>

        <button
          type="button"
          onClick={() => onNavigate('login')}
          className="mt-6 flex items-center gap-1.5 text-sm text-violet-600 hover:text-violet-700 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al login
        </button>
      </div>
    </div>
  );
}
